  import './contact.css'
  function Contact() {
  return (
    <div class="contact-card">
      <h1>Contact Us</h1>
      <p>Phone :+91 7310188293</p>
      Email :20bcs098@nith.ac.in
      <br></br>
   National Institute of Technology Hamirpur Himachal Pradesh
        <br></br>
      Basti,Uttar Pradesh ,272177
       <a>
        
       </a>
    </div>
    
  );
}
export default Contact;

